import { render, staticRenderFns } from "./UploadLedger.vue?vue&type=template&id=2fc0dee2&scoped=true"
import script from "./UploadLedger.vue?vue&type=script&lang=js"
export * from "./UploadLedger.vue?vue&type=script&lang=js"
import style0 from "./UploadLedger.vue?vue&type=style&index=0&id=2fc0dee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0dee2",
  null
  
)

export default component.exports